export default "__VITE_ASSET__C18Fe8Vq__"